import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { history } from '../../history';

import { RayTable, RayCodeListHeader } from '../../components/common';
import { LIST_STATE_KEYS } from '../../config/listStateKeys';
import { RayCodeAction } from '../../actions/RayCodeAction';
import { Translate as t } from '../../config/Translate';

const AdminRayCode = ({ GetAll, items, AddUpdate }) => {

	const [showType, setShowType] = useState("list");

	const options = {
		search: true,
		showClear: true,
		keyCol: '_id',
		linkkey: 'code',
		searchCols: ['group', 'code', 'name', 'category'],
		filterColumns: [
			{ col: 'type', val: 'ALL' },
		],
		defaultSort: 'code',
	};

	useEffect(() => {
		GetAll();
	}, []);

	const selected = (e) => {
		AddUpdate(e);
		history.push("/Admin/AdminRayCodeInfo");
	}

	const addNew = () => {
		AddUpdate({});
		history.push("/Admin/AdminRayCodeInfo");
	}

	return (
		<>
			<div className="extraHeader">
				<h2 className="mb-0">
					{t('product.label.rayCodeList')}
				</h2>
				<div className="ray-right">
					<button className="btn btn-primary btn-sm mt-0" onClick={() => addNew()}>
						<ion-icon name="add-outline"></ion-icon>
						{t('common.button.addCode')}
					</button>
				</div>
			</div>
			<div id="appCapsule" className="extra-header-active full-height">
				<div className="section mt-1 mb-1">
					<div className="wide-block pt-2 pb-2">
						<RayTable
							stateKey={LIST_STATE_KEYS.ADMIN_RAY_CODE}
							data={items}
							rowSelectCallback={(e) => selected(e)}
							callback={() => setShowType("list")}
							columns={RayCodeListHeader}
							options={options} />
					</div>
				</div>
			</div>
		</>
	);
};

const mapState = (state) => {
	const items = state.RayCodeReducer.items;
	return { items };
};

const mapDispatch = (dispatch) => ({
	GetAll: (filter) => dispatch(RayCodeAction.GetAll(filter)),
	AddUpdate: (item) => dispatch(RayCodeAction.AddUpdate(item)),
});

export default connect(mapState, mapDispatch)(AdminRayCode);